import { permissionKeys } from 'src/app/shared/constants/permissions';

export const menuData = [
  {
    id: 1,
    mainMenuLabel: 'Settings',
    icon: '../../../assets/setting.svg',
    selectedIcon: '../../../assets/setting-fill.svg',
    mainMenuPermission: 'settings',
    root: 'settings',
    path: 'settings',
    submenu: [
      {
        submenuLabel: 'Default',
        mainMenuLabel: 'Settings',
        icon: '../../../assets/default.svg',
        path: 'settings/core',
        subMenuPermission: 'prizeZone',
        insiderMenu: [
          {
            insiderMenuPermission: 'settings.core.prizone',
            insiderMenuLabel: 'Prize Zones',
            insiderMenuPath: 'settings/core/prizezones',
          },
          {
            insiderMenuPermission: 'settings.core.prizone',
            insiderMenuLabel: 'Prize Zones',
            insiderMenuPath: 'settings/core/prize-zone-details/:id',
          },
        ],
      },
      {
        submenuLabel: 'Leagues',
        mainMenuLabel: 'Settings',
        icon: '../../../assets/league-black.png',
        path: 'settings/leagues',
        subMenuPermission: 'league',
        insiderMenu: [],
      },
      {
        submenuLabel: 'Gateways',
        mainMenuLabel: 'Settings',
        icon: '../../../assets/payment-gateways-black.png',
        path: 'settings/gateways',
        subMenuPermission: 'gateways',
        insiderMenu: [],
      },
    ],
  },
  {
    id: 2,
    mainMenuLabel: 'DFF',
    icon: '../../../assets/dff.svg',
    selectedIcon: '../../../assets/dff-fill.svg',
    mainMenuPermission: 'dff',
    root: 'settings',
    path: 'dff',
    submenu: [
      {
        submenuLabel: 'Default',
        mainMenuLabel: 'DFF',
        icon: '../../../assets/default.svg',
        path: 'dff/core',
        subMenuPermission: permissionKeys.dff.DFF_SEASON,
        insiderMenu: [],
      },
      {
        submenuLabel: 'Matches',
        mainMenuLabel: 'DFF',
        icon: '../../../assets/core.png',
        path: 'dff/match-management',
        subMenuPermission: permissionKeys.dff.GAME_FIXTURE,
        insiderMenu: [],
      },
    ],
  },
  {
    id: 3,
    mainMenuLabel: 'SFF',
    icon: '../../../assets/dff.svg',
    selectedIcon: '../../../assets/dff-fill.svg',
    mainMenuPermission: 'sff',
    root: 'settings',
    path: 'sff',
    submenu: [
      {
        submenuLabel: 'Season',
        mainMenuLabel: 'SFF',
        icon: '../../../assets/default.svg',
        path: 'sff/seasons-list',
        subMenuPermission: 'sffSeasonLeague',
        insiderMenu: [],
      },
      {
        submenuLabel: 'RFT Match Days',
        mainMenuLabel: 'SFF',
        icon: '../../../assets/calendar-1.png',
        path: 'sff/rft-matchdays',
        subMenuPermission: 'sffMdPrizeZone',
        insiderMenu: [],
      },
    ],
  },
  {
    id: 4,
    mainMenuLabel: 'Accounts',
    icon: '../../../assets/bank.svg',
    selectedIcon: '../../../assets/bank-fill.svg',
    mainMenuPermission: 'accounts',
    root: 'settings',
    path: 'accounts',
    submenu: [
      {
        submenuLabel: 'Fiat Payments',
        mainMenuLabel: 'Accounts',
        icon: '../../../assets/payment.svg',
        path: 'accounts/payment',
        subMenuPermission: 'payment',
        insiderMenu: [],
      },
      {
        submenuLabel: 'Fiat Payouts',
        mainMenuLabel: 'Accounts',
        icon: '../../../assets/payout.svg',
        path: 'accounts/payout',
        subMenuPermission: 'payout',
        insiderMenu: [],
      },
      {
        submenuLabel: 'Sff Transactions',
        mainMenuLabel: 'Accounts',
        icon: '../../../assets/transaction.svg',
        path: 'accounts/user-sff-transactions',
        subMenuPermission: 'sffTransaction',
        insiderMenu: [],
      },
      {
        submenuLabel: 'Dff Transactions',
        mainMenuLabel: 'Accounts',
        icon: '../../../assets/transaction-type-black.png',
        path: 'accounts/user-dff-transactions',
        subMenuPermission: 'dffTransaction',
        insiderMenu: [],
      },

      {
        submenuLabel: 'Withdrawal Requests',
        mainMenuLabel: 'Accounts',
        icon: '../../../assets/transaction-type-black.png',
        path: 'accounts/user-withdrawal-requests',
        subMenuPermission: 'dffTransaction',
        insiderMenu: [],
      },
    ],
  },
  {
    id: 5,
    mainMenuLabel: 'Users',
    icon: '../../../assets/user.svg',
    selectedIcon: '../../../assets/user-fill.svg',
    mainMenuPermission: 'users',
    root: 'users',
    path: 'users',
    submenu: [
      {
        submenuLabel: 'Users',
        mainMenuLabel: 'Users',
        icon: '../../../assets/users.svg',
        path: 'users/users-list',
        subMenuPermission: 'user',
        insiderMenu: [],
      },
    ],
  },
  {
    id: 6,
    mainMenuLabel: 'Assets',
    icon: '../../../assets/assets.svg',
    selectedIcon: '../../../assets/assets-fill.svg',
    mainMenuPermission: 'assets',
    root: 'assets',
    path: 'assets',
    submenu: [
      {
        submenuLabel: 'Players',
        mainMenuLabel: 'Assets',
        icon: '../../../assets/player.svg',
        path: 'assets/players',
        subMenuPermission: 'assets',
        insiderMenu: [],
      },
      {
        submenuLabel: 'Clubs',
        mainMenuLabel: 'Assets',
        icon: '../../../assets/club-black.png',
        path: 'assets/clubs',
        subMenuPermission: 'assets',
        insiderMenu: [],
      },
    ],
  },
  {
    id: 7,
    mainMenuLabel: 'Notification',
    icon: '../../../assets/notification.png',
    selectedIcon: '../../../assets/notification.png',
    mainMenuPermission: 'notification',
    root: 'settings',
    path: 'notification',
    submenu: [
      {
        submenuLabel: 'global-notification',
        mainMenuLabel: 'Notification',
        icon: '../../../assets/player.svg',
        path: 'notification/GlobalNotification',
        subMenuPermission: 'notification',
        insiderMenu: [],
      },
      // {
      //     "submenuLabel": "subMenu2",
      //     "mainMenuLabel": "Notification",
      //     "icon": "../../../assets/club-black.png",
      //     "path": "notification/subMenu2",
      //     "subMenuPermission": "dff",
      //     "insiderMenu": [
      //     ]
      // }
    ],
  },
  {
    id: 8,
    mainMenuLabel: 'subscription',
    icon: '../../../assets/subscribe.png',
    selectedIcon: '../../../assets/assets-fill.svg',
    mainMenuPermission: 'subscription',
    root: 'settings',
    path: 'subscription',
    submenu: [
      {
        submenuLabel: 'League-Pack',
        mainMenuLabel: 'subscription',
        icon: '../../../assets/player.svg',
        path: 'subscription/leaguePack',
        subMenuPermission: 'leaguePack',
        insiderMenu: [],
      },
      {
        submenuLabel: 'Paid Transfer Pack',
        mainMenuLabel: 'Subscription',
        icon: '../../../assets/paid-transfer.png',
        path: 'subscription/paid-transfer-overview',
        subMenuPermission: 'paidTransferPacks',
        insiderMenu: [],
      },
    ],
  },
  {
    id: 9,
    mainMenuLabel: 'survey',
    icon: '../../../assets/survey.png',
    selectedIcon: '../../../assets/assets-fill.svg',
    mainMenuPermission: 'survey',
    root: 'settings',
    path: 'survey',
    submenu: [
      {
        submenuLabel: 'questionnaire',
        mainMenuLabel: 'survey',
        icon: '../../../assets/player.svg',
        path: 'survey/questionnaire',
        subMenuPermission: 'survey',
        insiderMenu: [],
      },
      {
        submenuLabel: 'question',
        mainMenuLabel: 'survey',
        icon: '../../../assets/player.svg',
        path: 'survey/question',
        subMenuPermission: 'survey',
        insiderMenu: [],
      },
    ],
  },
  {
    id: 10,
    mainMenuLabel: 'Refer & Earn',
    icon: '../../../assets/survey.png',
    selectedIcon: '../../../assets/default.svg',
    mainMenuPermission: 'refer-earn',
    root: 'settings',
    path: 'refer-earn',
    submenu: [
      {
        submenuLabel: 'RFT Referral',
        mainMenuLabel: 'Refer & Earn',
        icon: '../../../assets/player.svg',
        path: 'refer-earn/refer-list',
        subMenuPermission: 'rftReferral',
        insiderMenu: [],
      },
    ],
  },
  {
    id: 11,
    mainMenuLabel: 'Brands',
    icon: '../../../assets/brand-main.svg',
    selectedIcon: '../../../assets/brand-main.svg',
    mainMenuPermission: 'assets',
    root: 'assets',
    path: 'brands',
    submenu: [
      {
        submenuLabel: 'Brand List',
        mainMenuLabel: 'Brands',
        icon: '../../../assets/brand-sub.svg',
        path: 'brands/list',
        subMenuPermission: 'assets',
        insiderMenu: [
          {
            insiderMenuPermission: 'settings.core.prizone',
            insiderMenuLabel: 'Brand Details',
            insiderMenuPath: 'brands/details/:brandId',
          },
        ],
      },
      {
        submenuLabel: 'Brand Contest',
        mainMenuLabel: 'Brands',
        icon: '../../../assets/brand-contest-sub.svg',
        path: 'brands/contest',
        subMenuPermission: 'assets',
        insiderMenu: [],
      },
    ],
  },
];
